import * as Yup from 'yup'

export const FilterValidationSchema = Yup.object().shape({
  value: Yup.string().min(2).max(40).required(),
  filterType: Yup.string().required()
})
